import BaseTooltip from '@primitives/BaseTooltip';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { Image } from '@repo/ui/src/components/Image';
import { Markdown } from '@repo/ui/src/components/Markdown';
import Button from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { getButtonVariant } from '@repo/ui/src/components/Button/utils';
import { ImageProps, AmplienceButtonProps } from '@repo/ui/src/types';

export interface FlavorProps {
  buttons: Array<AmplienceButtonProps>;
  color: string;
  description: string;
  title: string;
  pairsWithIcons: Array<{
    icon: ImageProps;
    name: string;
  }>;
  woodImage: ImageProps;
  woodPelletsText: string;
  pairsWithText: string;
}

const WoodPelletFlavor = ({
  title,
  woodPelletsText,
  pairsWithText,
  description,
  pairsWithIcons,
  buttons,
  woodImage,
  color,
}: FlavorProps) => {
  const borderColor = color ? `${color}` : 'black';
  return (
    <div className="flex h-full w-full">
      <div style={{ borderRight: `4px solid ${borderColor}` }} className="h-full w-[100px]">
        <div className="h-[200px] relative w-[100px]">
          <Image
            src={buildImageSrc(woodImage, 900, 0, 0)}
            alt=""
            role="presentation"
            layout="fill"
            height={200}
            width={200}
            objectFit="cover"
            priority
          />
        </div>
      </div>
      <div className="py-2 pl-5 md:pt-16 md:pb-6 md:pl-12 flex flex-col justify-between">
        <h2 className="tra-text-web-heading-2 pb-5">{title}</h2>
        <p className="tra-text-web-sub-1 pb-5">{woodPelletsText}</p>
        <Markdown>{description}</Markdown>
        <div className="flex-1" />
        <h3 className="tra-text-web-body-l font-bold normal-case">{pairsWithText}</h3>
        <ul role="list" className="p-0 m-0 mb-6 flex flex-wrap list-none">
          {pairsWithIcons?.map(
            (icon) =>
              icon && (
                <li key={icon.name}>
                  {/* @ts-expect-error missing props */}
                  <BaseTooltip text={icon.name}>
                    <img
                      src={buildImageSrc(icon.icon, 40, 0, 0)}
                      alt=""
                      className="h-8 opacity-80 md:mr-2 md:my-2"
                    />
                  </BaseTooltip>
                </li>
              ),
          )}
        </ul>

        <div className="flex flex-row w-full">
          {buttons?.map((b: any, i) => (
            <div key={i} className="mr-4 justify-center">
              <Button
                as={Anchor}
                variant={getButtonVariant(b.style, b.icon)}
                size="small"
                {...b}
                {...b?.link}
              >
                {b?.link?.displayName}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WoodPelletFlavor;
